import { GoogleSignin } from "@/components/auth/google-signin";
import { MasterkeyLogo } from "@/components/masterkey-logo";

export const LoginSection = () => {
  return (
    <div className="w-full max-w-md">
      <MasterkeyLogo className="mb-8 hidden w-24 md:mb-32 md:block" />
      <h2 className="mb-6 text-2xl font-semibold md:text-3xl">
        Ready to Reimagine?
      </h2>
      <div className="space-y-3">
        <GoogleSignin />
      </div>
      <p className="mb-4 mt-2 text-center text-xs text-gray-500 md:mb-0 md:mt-4">
        By signing in, you agree to our{" "}
        <a href="/terms" className="underline">
          Terms
        </a>{" "}
        and{" "}
        <a href="/privacy" className="underline">
          Privacy Policy
        </a>
      </p>
      <div id="recaptcha-container" />
    </div>
  );
};
